import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import isUndefined from 'lodash/isUndefined';
import { useTranslation } from 'react-i18next';
type SubmittedVerifiedProps = {
  submitted?: boolean;
  verified?: boolean;
};
const SubmittedVerified = t0 => {
  const $ = _c(10);
  const {
    submitted,
    verified
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== submitted || $[2] !== t) {
    t2 = !isUndefined(submitted) && <p className="text-caption-1 text-tertiary">{submitted ? t(_temp) : t(_temp2)}</p>;
    $[1] = submitted;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t || $[5] !== verified) {
    t3 = !isUndefined(verified) && <><span className="text-tertiary">⋅</span><p className={cx("text-caption-1", {
        "text-success": verified,
        "text-error": !verified
      })}>{verified ? t(_temp3) : t(_temp4)}</p></>;
    $[4] = t;
    $[5] = verified;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex items-center gap-1">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default SubmittedVerified;
function _temp($) {
  return $.businessShared.tags.submitted;
}
function _temp2($_0) {
  return $_0.businessShared.tags.notSubmitted;
}
function _temp3($_1) {
  return $_1.businessShared.tags.verified;
}
function _temp4($_2) {
  return $_2.businessShared.tags.notVerified;
}